export default __webpack_public_path__ + "static/media/beautiful-family-standing-at-the-cash-counter2.b9f6ec5e.png";